"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;flex-direction:column;align-items:center;height:100%;padding-bottom:", (0, _util.rem)(12), ";background:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var logo = /*#__PURE__*/(0, _react.css)("flex-shrink:0;height:", (0, _util.rem)(48), ";width:", (0, _util.rem)(48), ";padding:", (0, _util.rem)(14), " ", (0, _util.rem)(16.5), ";img{width:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:logo;"));
var scrollingContainer = /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;flex:1;overflow-y:auto;margin-bottom:", (0, _util.rem)(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:scrollingContainer;"));
var styles = {
  base: base,
  logo: logo,
  scrollingContainer: scrollingContainer
};
exports.styles = styles;
//# sourceMappingURL=GlobalNav.styles.js.map